/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'ai-floating-context-menu.ai-dynamic-surface.back': 'voltar',
  'ai-floating-context-menu.ai-dynamic-surface.close': 'fechar',
  'ai-floating-context-menu.ai-dynamic-surface.referencing-panel-title': 'Referenciando',
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'Ações',
  'ai-smart-button.ai-actions.conversation-starters.loading.text': 'Carregando iniciadores de conversa...',
  'ai-smart-button.ai-actions.conversation-starters.section.text': 'Pergunte ao Rovo',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'Dar feedback',
  'ai-smart-button.ai-actions.help.section.text': 'Ajuda',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'Link',
  'ai-smart-button.ai-actions.input.mention-button-label': 'Mencionar',
  'ai-smart-button.ai-actions.input.placeholder': 'Digite o que você precisa',
  'ai-smart-button.ai-actions.input.send-button-label': 'Enviar',
  'ai-smart-button.ai-actions.item.betaLozenge': 'BETA',
  'ai-smart-button.ai-actions.item.newLozenge': 'NOVIDADE',
  'ai-smart-button.ai-actions.no-results-heading': 'Pergunte ao Rovo',
  'ai-smart-button.ai-actions.no-results-text': 'Envie sua solicitação para o Rovo para iniciar um bate-papo.',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'Adicionar ícone',
  'ai-smart-button.ai-actions.rovo-agents.agent-icon-label': 'Ícone de agente',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': 'Ícone de automação',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automações',
  'ai-smart-button.ai-actions.rovo-agents.browse-agent.text': 'Pesquisar agentes',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Criar agente',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Criar automação',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Estúdio',
  'ai-smart-button.ai-actions.static-agent-fallback-1': 'O que são Agentes Rovo?',
  'ai-smart-button.ai-actions.static-agent-fallback-2': 'Como posso usar Agentes Rovo no meu espaço do Confluence?',
  'ai-smart-button.ai-actions.static-fallback-1': 'O que é o Chat Rovo?',
  'ai-smart-button.ai-actions.static-fallback-2': 'Preciso de ajuda para começar com o Chat Rovo',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': 'Como posso ajudar?',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Oi, {name},',
  'ai-smart-button.ai-proactive-nudge.dismiss': 'Ignorar',
  'ai-smart-button.feedback-action.ask-question-option': 'Faça uma pergunta',
  'ai-smart-button.feedback-action.can-contact-message':
    'Sim, as equipes {product} podem entrar em contato comigo para saber mais sobre minhas experiências para melhorar os produtos e serviços da Atlassian. Eu reconheço a {privacyPolicy}',
  'ai-smart-button.feedback-action.cancel-button-label': 'Cancelar',
  'ai-smart-button.feedback-action.choose-feedback-option': 'Escolha um',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Descrever o bug ou item',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': 'Deixe a gente saber sua opinião',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'O que você gostaria de saber?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading':
    'Conte para a gente o que você acha que pode melhorar',
  'ai-smart-button.feedback-action.leave-comment-option': 'Deixar um comentário',
  'ai-smart-button.feedback-action.privacy-policy-link': 'Política de Privacidade do {product}.',
  'ai-smart-button.feedback-action.report-bug-option': 'Reportar um bug',
  'ai-smart-button.feedback-action.research-participation-message': 'Eu gostaria de participar da pesquisa de produtos',
  'ai-smart-button.feedback-action.select-feedback-heading': 'Selecionar feedback',
  'ai-smart-button.feedback-action.submit-button-label': 'Enviar feedback',
  'ai-smart-button.feedback-action.suggest-improvement-option': 'Sugerir uma melhoria',
  'ai-smart-button.feedback-action.title': 'Dar feedback',
  'ai-smart-button.feedback-item.icon-label': 'Ícone de feedback',
  'ai-smart-button.reference.close-button-label': 'Fechar',
  'ai-smart-button.tooltip.label': 'Pergunte à IA do Rovo',
  'quick-summary.feedback.summary.placeholder': 'O que o Atlassian Intelligence fez bem? O que pode melhorar?',
  'quick-summary.feedback.title': 'Ajude a gente a melhorar o Atlassian Intelligence',
};
